<template>
  <section>

    <h2 class="title">Payment</h2>
    <v-checkbox v-model="autoCCFee" label="Calculate CC Fee Automactically"></v-checkbox>
    <v-card class="my-5">
      <v-simple-table class="form-table">
        <template v-slot:default>
          <thead>
            <tr>
              <th>Item</th>
              <th>Description</th>
              <th>Value</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in form.payments" :key="`payments-${i}`">
              <td> 
                <v-select
                  :items="options"
                  v-model="item.type"
                  placeholder="Select Payment Method"
                  dense
                  solo 
                  flat
                  hide-details
                ></v-select>    
              </td>
              <td>
                <v-text-field
                  v-model="item.description"
                  placeholder="Add Description"
                  dense
                  solo 
                  flat
                  hide-details
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  v-model="item.value"
                  placeholder="Add Item Value"
                  dense
                  solo 
                  flat
                  hide-details
                  @keyup="updateCCFee()"
                  v-if="item.type === 'cc'"
                ></v-text-field>
                <v-text-field
                  v-model="item.value"
                  placeholder="Add Item Value"
                  dense
                  solo 
                  flat
                  hide-details
                  v-else
                ></v-text-field>
              </td>
              <td class="actions-cell">
                <v-btn icon color="success" @click="addItem()"><v-icon>add</v-icon></v-btn> 
                <v-btn icon color="warning" @click="removeItem(i)"><v-icon>remove</v-icon></v-btn> 
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

    </v-card>
    <v-textarea
      outlined
      class="my-5"
      label="Addtional Notes"
      v-model="form.notes"
    ></v-textarea>
  </section>
</template>

<script>

const defaultItem = { type: '', description: '', value: '' };

export default {
  name: "PaymentDetails",
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default: () => ([])
    }
  },
  data: (vm) => ({
    autoCCFee: true
  }),
  methods: {
    addItem() {
			this.form.payments.push({...defaultItem});
		},
		removeItem(i) {
			// this.form.items.splice(i, 1);
			if (this.form.payments.length === 1) {
				this.form.payments = [{...defaultItem}];
			} else {
				this.form.payments.splice(i, 1);
			}
      this.updateCCFee(true)
		},
    updateCCFee (forceUpdate = false) {
			// var val = e.target.value;
			// console.log(val)
			if (!this.autoCCFee && !forceUpdate) return;
			let cccharges = 0;
			this.form.payments.forEach((payment) => {
				if (payment.type === "cc") {
					cccharges += parseFloat(payment.value) || 0;
				}
			});

			if (cccharges > 0) {
				// todo add cc fee
				var val = cccharges;
				var fee = parseFloat((val * 0.03).toFixed(2));
				var ccFeeExist = false;
				var emptyItem = null;
				const ccfee = {...defaultItem};
				ccfee.type = "ccfee";
				ccfee.description = "Fee added for CC Payment " + val;
				ccfee.value = fee;
				this.form.items.forEach((item, i) => {
					if (item.type === 'ccfee') {
						// todo cc fee already exist update fee
						// alert("CC Fee updated");
						ccFeeExist = true;
						// this.form.items[i] = ccfee;
						this.form.items.splice(i, 1, ccfee)
					} else if (emptyItem === null && (!item.type || item.type === '')) {
						emptyItem = i;
					}
				});
				if (!ccFeeExist) {
					// todo add cc fee
					if (emptyItem != null) {
            this.form.items.splice(emptyItem, 1,ccfee);
					} else {
						this.form.items.push(ccfee);
					}
					// alert("CC Fee added")
				}
			} else {
				const cItem = {...defaultItem};
				this.form.items.forEach((item, i) => {
					if (item.type === 'ccfee') {
            this.form.items.splice(i, 1,cItem);
					}
				});
			}
    }
  }
};
</script>